/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { ApiClient } from '@shared/api-client';
import { Driver, User } from '@shared/models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DriversService extends ApiClient {
  constructor(private httpClient: HttpClient) {
    super();
  }

  getDrivers(filterValues = {} ): Observable<Driver[]> {
    const params = new HttpParams({fromObject: filterValues});
    return this.httpClient.get<Driver[]>(`${environment.backendServer}/api/drivers`, {
      headers: this.LD_JSON_HEADERS,
      params
    }).pipe(
      map(response => response['hydra:member'])
    );
  }

  getDriver(id: string): Observable<Driver> {
    return this.httpClient.get<Driver>(`${environment.backendServer}/api/drivers/${this.extractId(id)}`, {
      headers: this.LD_JSON_HEADERS
    });
  }

  createDriver(driver: Driver): Observable<Driver> {
    return this.httpClient.post<Driver>(`${environment.backendServer}/api/drivers`, driver, {
      headers: this.LD_JSON_HEADERS,
      observe: 'response'
    }).pipe(
      map(response => response.body)
    );
  }

  updateDriver(driver: Driver): Observable<Driver> {
    return this.httpClient.put<Driver>(`${environment.backendServer}/api/drivers/${this.extractId(driver['@id'])}`, driver, {
      headers: this.LD_JSON_HEADERS,
      observe: 'response'
    }).pipe(
      map(response => response.body)
    );
  }

  deleteDriver(id: string): Observable<any> {
    return this.httpClient.delete(`${environment.backendServer}/api/drivers/${this.extractId(id)}`, { observe: 'response' });
  }

  deactivateDriver(driver: Driver): Observable<void> {
    return this.httpClient.post<void>(`${environment.backendServer}/api/driver/${this.extractId(driver['@id'])}/deactivate`,
      {},
      {
      headers: this.LD_JSON_HEADERS,
      observe: 'response'
    }).pipe(
      map(response => response.body)
    );
  }
}
